var hoverSpeakers = function(){
  var body;
  var speakers;
  var currentTarget;
  var animationClasses;

  var _init = function(){
    body = document.body;
    speakers = document.getElementsByClassName('m-eday-speaker');
    animationClasses = ['lazy-load--left','lazy-load--right', 'lazy-load--top'];

    _addEventListeners();
  };

  var _addEventListeners = function(){

    [].map.call(speakers, function(speaker){
      if (speaker.classList.contains('m-eday-speaker--cta')) {return false;}
      var idx = Math.floor(Math.random() * animationClasses.length);

      _addAnimationClass(speaker, animationClasses[idx]);
      speaker.addEventListener('mouseenter', _onMouseEnter);
      speaker.addEventListener('mouseleave', _onMouseLeave);
    });
  };

  var _onMouseEnter = function(e){
    body.classList.add('is-speaker-hovered');
    currentTarget =  e.currentTarget;
    currentTarget.classList.add('visible');
  }

  var _onMouseLeave = function(){
    body.classList.remove('is-speaker-hovered');
    currentTarget.classList.remove('visible');
    currentTarget;
  }

  var _addAnimationClass = function(speaker, className){
    if (speaker.classList.contains('m-eday-speaker--cta')) {
      return;
    }

    speaker.querySelector('figure').classList.add(className);
  };

  return {
    init: _init
  }
}();

if (document.getElementsByClassName('m-eday-speaker')) {
  hoverSpeakers.init();
}


// WEBPACK FOOTER //
// ./resources/assets/js/partials/SpeakersHoverEffect.js